import { render } from "./AboutView.vue?vue&type=template&id=5768bf35"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=5768bf35&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__